export default [
  {
    key: 'name',
    label: 'field.name',
    type: 'text',
    rules: 'required|max:100'
  },
  {
    key: 'workScheduleId',
    label: 'breadcrumb.workingSchedule',
    type: 'async-single-selection',
    repository: 'workingScheduleTemplate',
    selectionKey: 'id',
    selectionLabel: 'title',
    rules: 'required',
  },
  {
    key: 'isActive',
    label: 'field.status',
    type: 'radio',
    rules: 'required',
    options: [
      { text: 'status.active', value: true },
      { text: 'status.inactive', value: false }
    ],
    cols: 6
  }
];
